import React from 'react';
import { Placeholder } from 'react-bootstrap';

// Uma linha por largura de título (.dc.html:726): variar a largura evita o efeito "listrado".
const TITLE_WIDTHS = ['62%', '48%', '70%', '55%', '40%'] as const;
// Reenviar, Baixar, Cancelar e Excluir: os 4 botões de ação de cada linha.
const ACTION_SLOTS = ['resend', 'download', 'cancel', 'delete'] as const;

/**
 * Skeleton da lista da aba Meus Estudos (.dc.html:248-258): 5 linhas na mesma grade das linhas
 * reais, com 4 quadrados de 38×38 px na coluna de ações. Só o texto "Carregando estudos…" é
 * anunciado; as barras são decorativas.
 */
export default function ListSkeleton() {
  return (
    <div className="my-studies-skeleton" aria-busy="true">
      <span className="visually-hidden" role="status">Carregando estudos…</span>
      {TITLE_WIDTHS.map((titleWidth) => (
        <Placeholder
          key={titleWidth}
          as="div"
          animation="glow"
          className="my-studies-grid my-studies-skeleton-row"
          data-testid="my-studies-skeleton-row"
          aria-hidden="true"
        >
          <div className="my-studies-skeleton-cell">
            <Placeholder
              className="my-studies-skeleton-strong my-studies-skeleton-title"
              style={{ width: titleWidth }}
            />
            <Placeholder className="my-studies-skeleton-subtitle" />
          </div>
          <div className="my-studies-skeleton-cell">
            <Placeholder className="my-studies-skeleton-strong my-studies-skeleton-horizon" />
            <Placeholder className="my-studies-skeleton-horizon-detail" />
          </div>
          <div className="my-studies-skeleton-cell">
            <Placeholder className="my-studies-skeleton-strong my-studies-skeleton-status" />
            <Placeholder className="my-studies-skeleton-status-detail" />
          </div>
          <div className="my-studies-skeleton-actions">
            {ACTION_SLOTS.map((slot) => (
              <Placeholder key={slot} className="my-studies-skeleton-action" />
            ))}
          </div>
          <div />
        </Placeholder>
      ))}
    </div>
  );
}
